// @flow
import React, { type Element } from 'react';
import DashboardEdit from './DashboardEdit';

const DashboardList = (): Element<*> => <DashboardEdit />;

export default DashboardList;
